import { PartySizeDurationDTO } from '@services/DTO/PartySizeDurationDTO'
import { ReasonDateRangeFilterDTO } from '@services/DTO/ReasonDateRangeFilterDTO'
import { ReasonScheduleRuleDTO } from '@services/DTO/ReasonScheduleRuleDTO'
import { ChargeRangeDTO } from '@services/DTO/ChargeRangeDTO'

export class BookingReasonDTO {
    constructor(
        public id: string,
        public displayName: string,
        public displayOrder: number,
        public description: string | null,
        public contributesToKitchenVelocity: boolean,
        public schedule: ReasonScheduleRuleDTO[],
        public dateRangeFilters: ReasonDateRangeFilterDTO[],
        public areaBookingOrder: string[] | null,
        public bookingDurations: PartySizeDurationDTO[],
        public diningInformation: string | null,
        public minimumPartySize: number | null,
        public maximumPartySize: number | null,
        public linkExclusive: boolean,
        public dailyCoverLimit: number | null,
        public bookingLimit: number | null,
        public coverLimit: number | null,
        public cancellationChargeRanges: ChargeRangeDTO[],
        public depositChargeRanges: ChargeRangeDTO[],
        public largePartyNoAvailabilityMessage: string | null,
        public merchantBookingsRequireChargeByDefault: boolean | null,
        public preorderMenuId: string | null,
        public sendPreOrderMenuId: string | null,
        public sendPreOrderMenuMinPartySize: number | null,
        public preBookingWindowMinutes: number | null,
        public displayedOpeningTimes: string | null,
        public reserveWithGoogleEnabled: boolean = false,
        public imageId: string | null = null,
        public calendarColour: string | null = null,
        public isActive: boolean = true
    ) { }
}
